<template>
  <v-container class="mt-5">
    <v-card outlined>
      <v-card-title>
        <span class="text-h5">Class List</span>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="goToCreateClass">
          <v-icon left>mdi-plus</v-icon>
          New Class
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="classList"
        class="elevation-1"
        item-key="id"
        disable-sort
      >
        <template v-slot:item.actions="{ item }">
          <v-btn icon color="blue" @click="openEditDialog(item)">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <!-- <v-btn icon color="red" @click="deleteClass(item.id)">
            <v-icon>mdi-delete</v-icon>
          </v-btn> -->
        </template>

        <template v-slot:no-data>
          <v-alert type="info" class="ma-4">
            No classes found. Click "New Class" to add one.
          </v-alert>
        </template>
      </v-data-table>
    </v-card>

    <!-- Edit Class Dialog -->
    <v-dialog v-model="editDialog" max-width="500px">
      <v-card>
        <v-card-title>Edit Class</v-card-title>
        <v-card-text>
          <v-form ref="editForm">
            <v-text-field
              v-model="editData.name"
              label="Class Name"
              required
            ></v-text-field>
            <v-autocomplete
  v-model="editData.grade"
  :items="grades"
  label="Grade"
  required
  dense
  clearable
  outlined
  solo
></v-autocomplete>
            <v-select
  v-model="editData.level"
  :items="levels"
  label="Level"
  required
></v-select>
            <v-textarea
              v-model="editData.description"
              label="Description"
              rows="3"
              required
            ></v-textarea>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeEditDialog">Cancel</v-btn>
          <v-btn color="green darken-1" text @click="saveEdit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from 'axios'; // Ensure axios is installed and imported

export default {
  name: 'ClassList',
  data() {
    return {
      headers: [
        { text: 'Class Name', value: 'name' },
        { text: 'Level', value: 'level' },
        { text: 'Description', value: 'description' },
        { text: 'Actions', value: 'actions', sortable: false }
      ],
      classList: [],
      editDialog: false,
      editData: {
        id: null,
        name: '',
        level: '',
        description: '',
        grade:'',
        display_name:'',
      },
      levels: ['Elementary', 'Middle', 'High'], // or fetch dynamically from API
      loading: false,
      grades: [
        'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
        'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
        'U', 'V', 'W', 'X', 'Y', 'Z',
        'I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'
      ],
    };
  },
  created() {
    this.getClasses();
  },
    watch: {
  'editData.grade'(newGrade) {
    this.appendGradeToName();
  },
  'editData.name'(newName) {
    this.appendGradeToName();
  }
},
  methods: {
    appendGradeToName() {
      if (!this.editData || typeof this.editData.name !== 'string') return;
    const rawName = this.editData.name.split(' (')[0].trim(); // remove existing grade suffix
    this.editData.display_name = rawName; // Store raw name separately
    if (rawName && this.editData.grade) {
      this.editData.name = `${rawName} (${this.editData.grade})`;
    } else {
      this.editData.name = rawName;
    }
  },
    async getClasses() {
      this.loading = true;
      try {
        const response = await axios.get('grade/getClasses',{
          params: {
            school_id: localStorage.getItem('user_id') // Adjust based on your store structure
          }
        }); // Replace with your real endpoint
        this.classList = response.data.data || response.data; // Adjust based on API response structure
      } catch (error) {
        console.error('Failed to fetch classes:', error);
        this.$toast?.error('Failed to load class list'); // Optional: toast notification
      } finally {
        this.loading = false;
      }
    },
    goToCreateClass() {
      this.$router.push({ name: 'create-class' });
    },
    deleteClass(id) {
      this.classList = this.classList.filter(cls => cls.id !== id);
    },
    openEditDialog(item) {
      this.editData = { ...item };
      this.editDialog = true;
    },
    closeEditDialog() {
      this.editDialog = false;
      this.resetEditForm();
    },
   async saveEdit() {
      try {
    const response = await axios.post('grade/updateClass', {
      class_id: this.editData.id,
      name: this.editData.name,
      level: this.editData.level,
      description: this.editData.description,
      grade:this.editData.grade,
      display_name:this.editData.display_name,
      school_id: localStorage.getItem('user_id') // if required by backend
    });

    // Update local list after successful response
    const index = this.classList.findIndex(cls => cls.id === this.editData.id);
    if (index !== -1) {
      this.classList.splice(index, 1, { ...this.editData });
    }

    this.$swal('success', 'Class updated successfully!');
    this.closeEditDialog();
  } catch (error) {
    console.error('Error updating class:', error);
    this.$toast?.error('Failed to update class');
  }
    },
    resetEditForm() {
      this.editData = {
        id: null,
        className: '',
        description: '',
        grade:'',
        display_name:'',
      };
    }
  }
}
</script>

